import { ChangeEvent } from 'react';

interface Option {
  title: string;
  value?: string | number;
}

type Callback = (data: { value: string | null }) => void;

const compare =
  (currentValue: string | number) =>
  ({ value }: Option): boolean =>
    String(currentValue) === String(value);

export const eventHandlerWrapper =
  (cb: Callback, options: Option[]) =>
  (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>): void => {
    const currentValue = e.target.value;

    const selectedOption = options.find(compare(currentValue));
    const value = selectedOption ? currentValue : null;

    return cb({ value });
  };
